<template>
  <app-page-subsection>
    <template #title>
      <span v-html="title" />
    </template>

    <teacher-card-carousel :list="list" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { TeacherListView } from "~/business-areas/teacher/teacher.model";
import type { TagPageApiView } from "~~/model/tag-page.model";

const properties = defineProps<{
  view: TagPageApiView;
  list: TeacherListView[];
}>();

const title = computed(
  () =>
    `Trainers - <span class="font-normal">${properties.view?.tag.label}</span>`,
);
</script>
